module.exports = __webpack_public_path__ + "img/loaderrimg.11ef3024.png";